module.exports = __webpack_public_path__ + "static/media/saveData.bf9fae5e.svg";